// @flow
import * as React from 'react';
import styled, { type StyledComponent } from 'styled-components';
import { Chip } from '../../chips';
import _ from 'underscore';

type SelectedChipsProps = {
  selectedItems: Array<any>,
  removeSelectedItem: (item: any) => void,
  getSelectedItemProps: (options: { selectedItem: any, index: number }) => any,
};

const SelectedChips = ({
  selectedItems,
  removeSelectedItem,
  getSelectedItemProps,
}: SelectedChipsProps) => {
  if (_.isEmpty(selectedItems)) {
    return null;
  }

  return (
    <SelectedChipWrapper>
      {selectedItems.map((selectedItem, index) => (
        <span
          key={`selected-item-${index}`}
          {...getSelectedItemProps({
            selectedItem: selectedItem.value,
            index,
          })}
        >
          <Chip
            data-provides={`selected-item-${selectedItem.value}`}
            text={selectedItem.label}
            onRemove={(e) => {
              e.stopPropagation();
              removeSelectedItem(selectedItem);
            }}
          />
        </span>
      ))}
    </SelectedChipWrapper>
  );
};

const SelectedChipWrapper: StyledComponent<*, *, *> = styled.span`
  display: flex;
  gap: 0.5rem;
  padding: 1.6875rem 0.5rem 0.5rem 0;
  white-space: nowrap;
`;

export default SelectedChips;
